import { __assign } from "tslib";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box, Typography } from '@mui/material';
/**
 * This component will show a set of images/logos in a horizontal way and collapse those that will not fit the
 * `numberBeforeTruncate` property.
 */
export var LimitedRowImages = function (_a) {
    var items = _a.items, numberBeforeTruncate = _a.numberBeforeTruncate;
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return _jsx(_Fragment, { children: "No supported devices" });
    }
    var slicedItems = items.slice(0, numberBeforeTruncate !== null && numberBeforeTruncate !== void 0 ? numberBeforeTruncate : 3);
    return (_jsxs(Box, __assign({ display: "flex", flexDirection: "row", alignItems: "center" }, { children: [slicedItems.map(function (item, index) {
                var _a;
                return (_jsx(Avatar, { variant: "square", alt: item.name, src: (_a = item.logo) !== null && _a !== void 0 ? _a : '', sx: {
                        width: 24,
                        height: 24,
                        marginRight: 1,
                    } }, index));
            }), ' ', items.length > slicedItems.length && (_jsxs(Typography, __assign({ height: "fit-content", variant: "smallText" }, { children: ["+ ", items.length - slicedItems.length, " more"] })))] })));
};
